import CoreBase from '../../services/engines/CoreBase';
import prioUpdater from '../../components/shared/PrioUpdater';

/**
 * NewNoteSaver — maps CreateNoteDlgWidget inputs to a prioUpdater-compatible entry and saves.
 * Inputs come from createEmpty() shape — no rk, stateId, isPinned, viewMode.
 * Those are set to their defaults here before delegating to prioUpdater.
 */
class NewNoteSaver extends CoreBase {
    _name = 'NewNoteSaver';

    /**
     * @param {object} inputs - createEmpty() shape
     */
    save = async (inputs) => {
        try {
            const entry = {
                rk: null,
                title: inputs.title,
                service: inputs.service,
                cat: inputs.cat,
                type: inputs.type,
                stage: inputs.stage,
                format: inputs.format,
                importanceId: inputs.importanceId,
                prioId: inputs.prioId,
                tid: inputs.tid,
                stateId: 0,
                isPinned: false,
                viewMode: null,
                remark: inputs.remark,
            };
            await prioUpdater.save(entry, null);
        } catch (error) {
            this.logError('save', error.message);
        }
    };
}

const newNoteSaver = new NewNoteSaver();
export default newNoteSaver;
